// Customers see the brand's lead time plus carrier transit, never the lead time itself.
export const CARRIER_DAYS = { min: 2, max: 5 };

const toDays = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? n : null;
};

// lead_days_min/max when the brand has set them, else the legacy single ship_time.
export const leadDays = (shippingAddress) => {
  if (!shippingAddress) return null;
  const legacy = toDays(shippingAddress.ship_time);
  const min = toDays(shippingAddress.lead_days_min) ?? legacy;
  const max = toDays(shippingAddress.lead_days_max) ?? legacy ?? min;
  if (min === null) return null;
  return { min, max: Math.max(min, max) };
};

export const deliveryEstimate = (shippingAddress) => {
  const lead = leadDays(shippingAddress);
  if (!lead) return '';
  return `Estimated delivery: ${lead.min + CARRIER_DAYS.min}–${lead.max + CARRIER_DAYS.max} business days`;
};
